/* istanbul ignore file */
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const compalAdminNavigationEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-compal-admin-navigation" */ './src/ui').then(
			(module) => module.AdminNavCommands,
		),
	),
	getPreloadProps: () => ({}),
});
